<template>
  <EasyDialog
    v-model="isVisible"
    hide-header
    width="fit-content"
    persistent
    :min-width="300"
    modal-class="excluded"
    data-cy="confirm-modal"
  >
    <div
      data-cy="confirm-modal-body"
      class="p-4 flex flex-col gap-6 justify-start"
    >
      <div class="flex gap-5 justify-start">
        <DSIcon
          icon="o-warning"
          class="text-important"
          :size="DS_ICON_SIZES.ExtraLarge"
        />
        <div class="flex flex-col gap-2">
          <span class="font-bold">{{ texts.title }}</span>
          <span>{{ texts.description }}</span>
          <slot />
        </div>
      </div>
    </div>
    <template #footer>
      <EasyDialogFooter
        :cancel-btn-label="texts.cancelBtnLabel"
        :confirm-btn-label="texts.confirmBtnLabel"
        :hide-cancel-btn="props.hideCancelBtn"
        @close:clicked="handleCancel"
        @ok:clicked="handleConfirm"
      />
    </template>
  </EasyDialog>
</template>

<script setup lang="ts">
// TODO remove app/frontend/src/shared/components/generalComponents/dialog/ConfirmDialog.vue
// TODO implement EasyConfirm into ForceAcquisitionModal.vue
// https://es.easy8.com/issues/615454
import EasyDialog from "@/src/easy-ui/components/EasyDialog.vue";
import { DSIcon } from "@/src/design_system";
import { DS_ICON_SIZES } from "@/src/design_system/primitives/icon/types";
import { computed, onMounted, ref } from "vue";
import EasyDialogFooter from "@/src/easy-ui/components/EasyDialogFooter.vue";

const t = window.EasyLocale.getLocale;

interface Props {
  cancelBtnLabel?: string;
  confirmBtnLabel?: string;
  title?: string;
  description?: string;
  hideCancelBtn?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  cancelBtnLabel: "",
  confirmBtnLabel: "",
  title: "",
  description: "",
  hideCancelBtn: false,
});

interface Emits {
  (e: "click:ok"): void;
  (e: "click:close"): void;
}

const emit = defineEmits<Emits>();

const isVisible = ref<boolean>(false);

const handleCancel = () => {
  emit("click:close");
  isVisible.value = false;
};

const handleConfirm = async () => {
  emit("click:ok");
  isVisible.value = false;
};

const texts = computed(() => {
  return {
    title: props.title || t("label_confirmation"),
    description: props.description || t("text_are_you_sure"),
    confirmBtnLabel: props.confirmBtnLabel || t("button_confirm"),
    cancelBtnLabel: props.cancelBtnLabel || t("button_cancel"),
  };
});

onMounted(() => {
  isVisible.value = true;
});
</script>
